import { localize } from 'helpers/translator/localize'
import localErrorCodes from 'helpers/enums/errors/localErrorCodes'

function NearpodError(
	error_code = localErrorCodes.GENERIC_ERROR,
	message,
	payload
) {
	this.error_code = error_code
	this.message = message
	this.payload = payload

	// This attributes are to mantain backward compatibility
	// Will be removed in the future
	this.serverData = this.getSerialData()
	this.serverError = this.getSerialData()
}
NearpodError.prototype = Object.create(Error.prototype)
NearpodError.prototype.constructor = NearpodError
NearpodError.prototype.name = 'NearpodError'
NearpodError.prototype.getSerialData = function() {
	return {
		...(typeof this.error_code !== 'undefined') && { error_code: this.error_code },
		...(typeof this.message !== 'undefined') && { message: this.message },
		...(typeof this.payload !== 'undefined') && { payload: this.payload },
	}
}

function formatError(error) {
	error = error || new NearpodError(localErrorCodes.GENERIC_ERROR)
	let nearpodError
	if (error.constructor === NearpodError) {
		nearpodError = error
	} else if (error.serverError) {
		nearpodError = new NearpodError(
			error.serverError.error_code || localErrorCodes.GENERIC_ERROR,
			error.serverError.message || localize('global_generic_error'),
			error.serverError.payload
		)
	} else {
		nearpodError = new NearpodError(
			localErrorCodes.GENERIC_ERROR,
			localize('global_generic_error'),
		)
	}
	return nearpodError.getSerialData()
}

export default formatError

export {
	NearpodError,
	formatError,
}
